import React from 'react'
import PropTypes from 'prop-types'

import PageSection from '../../../../../../features/components/PageSection'
import ItemsLoading from '../../../../../../components/Loaders/ItemsLoading'
import FacebookSocialPostCard from './FacebookSocialPostCard'
import SkeletonFacebookSocialPostCard from './FacebookSocialPostCard/Skeleton'

import {
  rightSocialPostsErrorSelector,
  rightSocialPostsIsLoadingSelector,
  rightSocialPostsWasLoadedSelector
} from '../../../../../../modules/selectors/rights'

import useStyles from '../styles'

const FacebookSocialPosts = ({ posts, facebookPageData, additionalDataIsLoading }) => {
  const classes = useStyles()

  return (
    <ItemsLoading
      itemsLength={posts.length}
      className={classes.cardsList}
      noDataText={'There are no social posts to show'}
      isLoadingSelector={rightSocialPostsIsLoadingSelector}
      wasLoadedSelector={rightSocialPostsWasLoadedSelector}
      errorSelector={rightSocialPostsErrorSelector}
      additionalDataIsLoading={additionalDataIsLoading}
      initialLoadingSkeletonsNumber={3}
      SkeletonComponent={SkeletonFacebookSocialPostCard}
      ContentWrapper={PageSection}
    >
      {posts.map((post, index) => (
        <FacebookSocialPostCard key={index} post={post} facebookPageData={facebookPageData} />
      ))}
    </ItemsLoading>
  )
}

FacebookSocialPosts.propTypes = {
  posts: PropTypes.array.isRequired,
  facebookPageData: PropTypes.object,
  additionalDataIsLoading: PropTypes.bool
}

export default FacebookSocialPosts
